import React from "react";
import {usePackQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";
import { GraphQlSelectId } from "./GraphQlSelectId";

export const PanelPackSelect = (props) => {
    const query = usePackQueryQuery();
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="label" />:<GraphQlSelect queryResult={query} {...props}  labelField="label" />;
//    return <GraphQlSelect queryResult={query} {...props}  labelField="label" />;
}
